export const FooterLinkFaq =
  "https://dallascounty.quickbase.com/up/buf2queft/g/rb/eh/vb/";

export const FooterLinkPEPD =
  "https://www.dallascounty.org/departments/dchhs/public-health/emergency-preparedness/";

export const genericErrorMessage =
  "Failed to process your request | No se pudo procesar su solicitud";

export const DocumentTypes = {
  requestorIDGroupAUpload_F: 1,
  requestorIDGroupBUpload_F: 2,
  requestorIDGroupCUpload_F: 3,
  poaUpload_F: 4,
  proofGuardianshipUpload_F: 5,
  immDIRConsentUpload_F: 6,
  immTracConsentFormUpload_F: 7,
  minorConsentUpload_F: 8,
  additionalDocumentUpload_F: 9,
};
